import React, { useState } from 'react';
import ActionButton from './ActionButton';
import { StyledSelect } from '../../RouteExecution/Pickups/PickupManagement/components/Select';
import { isEqual } from 'lodash/lang';

const getFieldError = (field, value) => {
  switch (field) {
    case 'inboundTerminal':
      return value?.trim() ? null : '* Required';
    case 'tractorStatus':
      return value?.trim() ? null : '* Required';
    default:
      return null;
  }
};

const UpdateTractor = ({
  assetInfo,
  updateEquipment,
  terminalOptions,
  statusOptions,
  classes,
  updateInProgress,
  onClose,
  formErrorMessage,
  clearFormErrorMessage
}) => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [tractorInfo, setTractorInfo] = useState({
    inboundTerminal: assetInfo?.inboundTerminal || null,
    tractorStatus: assetInfo?.tractorStatus || null
  });
  const [errorInfo, setErrorInfo] = useState(null);

  const handleChange = (name) => (value) => {
    value = value?.value || null;
    setTractorInfo((state) => ({
      ...state,
      [name]: value
    }));
    setErrorInfo((state) => ({
      ...state,
      [name]: getFieldError(name, value)
    }));
    if (errorMessage) {
      setErrorMessage(null);
    }
    if (formErrorMessage) {
      clearFormErrorMessage();
    }
  };

  const getErrorInfo = () => {
    let errorInfo = {};
    Object.keys(tractorInfo).forEach((fieldName) => {
      errorInfo[fieldName] = getFieldError(fieldName, tractorInfo[fieldName]);
    });
    setErrorInfo(errorInfo);
    return errorInfo;
  };

  const updateTractor = () => {
    const errorInfo = getErrorInfo();
    const errorData = Object.values(errorInfo).filter((value) => value).length;
    if (!errorData) {
      const data = {
        ...assetInfo,
        ...tractorInfo
      };
      if (isEqual(data, assetInfo)) {
        setErrorMessage('No changes to update');
        return;
      }
      updateEquipment({
        equipmentId: data.tractorId,
        equipmentNumber: data.tractorNumber,
        equipmentStatus: data.tractorStatus,
        equipmentScac: data.tractorScac,
        equipmentType: data.tractorType,
        inboundTerminal: data.inboundTerminal,
        outboundTerminal: data.outboundTerminal
      });
    }
  };

  return (
    <>
      <div className={classes.formValue}>
        <StyledSelect
          textFieldProps={{
            id: 'TractorStatus',
            label: 'Tractor Status',
            variant: 'outlined',
            helperText: errorInfo?.tractorStatus
          }}
          value={tractorInfo?.tractorStatus}
          error={errorInfo?.tractorStatus}
          onChange={handleChange('tractorStatus')}
          data={statusOptions}
        />
      </div>

      <div className={classes.formValue}>
        <StyledSelect
          textFieldProps={{
            id: 'CurrentTerminal',
            label: 'Current Terminal',
            variant: 'outlined',
            helperText: errorInfo?.inboundTerminal
          }}
          value={tractorInfo?.inboundTerminal}
          error={errorInfo?.inboundTerminal}
          onChange={handleChange('inboundTerminal')}
          data={terminalOptions}
        />
      </div>
      {errorMessage || formErrorMessage ? (
        <div className={classes.errorMessage}>{errorMessage || formErrorMessage}</div>
      ) : null}
      <ActionButton
        classes={classes}
        onClose={onClose}
        updateInProgress={updateInProgress}
        updateEquipment={updateTractor}
        errorMessage={errorMessage}
      />
    </>
  );
};

export default UpdateTractor;
